import apiTool from './index';

const LOGIN_URL = 'kuser/connexion/';
const REGISTER_URL = 'kuser/process-registration/';
const GET_USER_URL = 'kuser/get-user/';
const FORGET_PASSWORD_URL = 'kuser/forgot-password/'

export default {
  login(payload) {
    return apiTool.post(LOGIN_URL, payload);
  },
  getUser() {
    return apiTool.get(GET_USER_URL);
  },
  register(payload) {
    return apiTool.post(REGISTER_URL, payload);
  },
  forgetPassword(payload) {
    return apiTool.post(FORGET_PASSWORD_URL, payload);
  },
};
